import axios from 'axios'
import {router} from '../routes'

// https://medium.com/techvblogs/spa-authentication-using-laravel-sanctum-and-vue-js-6f81b6410a2b

export default {
    namespaced: true,
    state: {
        settings: {} // les commandes se trouvent dans l'objet user
    },
    getters: {
        //
    },
    mutations: {
        setSettings (state, settings) {
            state.settings = settings;
            // console.log("set Settings", settings)
        },
    },
    actions: {
        async initSettings(context) {
            const settings = (await axios.get(`/api/settings`)).data.data;
            context.commit('setSettings', settings);
        }
    },
};
